var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPredictable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#004887"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 35C17.9 35 13 30.1 13 24C13 17.9 17.9 13 24 13C30.1 13 35 17.9 35 24C35 30.1 30.1 35 24 35ZM24 15C19 15 15 19 15 24C15 29 19 33 24 33C29 33 33 29 33 24C33 19 29 15 24 15Z",
    fill: "#FCFCFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 25C23.4 25 23 24.6 23 24V20C23 19.4 23.4 19 24 19C24.6 19 25 19.4 25 20V24C25 24.6 24.6 25 24 25Z",
    fill: "#FCFCFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 29C23.7 29 23.5 28.9 23.3 28.7C23.1 28.5 23 28.3 23 28C23 27.9 23 27.7 23.1 27.6C23.2 27.5 23.2 27.4 23.3 27.3C23.6 27 24 26.9 24.4 27.1C24.5 27.1 24.5 27.1 24.6 27.2C24.6 27.2 24.7 27.3 24.8 27.3C24.9 27.4 25 27.5 25 27.6C25 27.7 25 27.9 25 28C25 28.1 25 28.3 24.9 28.4C24.8 28.5 24.8 28.6 24.7 28.7C24.5 28.9 24.3 29 24 29Z",
    fill: "#FCFCFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPredictable);
export default __webpack_public_path__ + "static/media/predictable.bcae6e04bcf9e564f9898af8dc5a800e.svg";
export { ForwardRef as ReactComponent };